module.exports = __webpack_public_path__ + "img/flapp_match_logo.96edb03a.svg";